// Composables
import { createRouter, createWebHistory } from 'vue-router';
import { trackRouter } from "vue-gtag-next";

// import AppSettings from '../views/AppSettings.vue';
// import Login from '../views/Login.vue';
// import AdminPanel from '../views/AdminPanel.vue';
// import ActionList from '../views/ActionList.vue';
// import Dashboard from '../views/Dashboard.vue';
// import EsignDashboard from '../views/EsignDashboard.vue';
// import Esign from '../views/Esign.vue';
// import Configuration from '../views/Configuration.vue';
// import ErrorStatusConfig from '../views/ErrorStatusConfig.vue';
// import WarehouseProConfig from '../views/WarehouseProConfig.vue';
// import SalesProConfig from '../views/SalesProConfig.vue';
// import WarehouseProStageOrders from '../views/WarehouseProStageOrders.vue';
// import TwilioAlertsConfiguration from '../views/TwilioAlertsConfiguration.vue';
// import TransactionConfig from '../views/TransactionConfig.vue';
// import TimeZoneConfig from '../views/TimeZoneConfig.vue';
// import GeneralConfigurations from '../views/GeneralConfigurations.vue';
// // import Warehouse from '../views/warehouse.vue';
// import Settlements from '../views/Settlements.vue';
// import Tickets from '../views/Tickets.vue';
// // import Settlements from './views/Settlements.vue';
import PhysicalCount from '../views/PhysicalCount.vue'



const routes = [
  // {
  //   path: '/',
  //   component: () => import('@/layouts/default/Default.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'Home',
  //       // route level code-splitting
  //       // this generates a separate chunk (Home-[hash].js) for this route
  //       // which is lazy-loaded when the route is visited.
  //       component: () => import('@/views/Home.vue'),
  //     },
  //   ],
  // },
  {
    path: '/',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/appSettings',
    name: 'appSettings',
    // component: AppSettings,
    component: () => import('@/views/AppSettings.vue'),
  },
  {
    path: '/PhysicalCountGrid',
    name: 'PhysicalCountGrid',
    component: () => import('@/components/PhysicalCountGrid.component.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    // component: Login,
    props: true,
  },
  {
    path: '/AdminPanel',
    name: 'adminPanel',
    component: () => import('@/views/AdminPanel.vue'),
    // component: AdminPanel,
    // props: true,
    children: [
      {
        name:'adminPanel',
        path: '',
        redirect: {
          name: 'errorstatusconfig'
        }
      },
      {
        path: '/ErrorStatusConfig',
        name: 'errorstatusconfig',
        component: () => import('@/views/ErrorStatusConfig.vue'),
        // component: ErrorStatusConfig,
        alias: '/'
      },
      {
        path: '/WarehouseProConfig',
        name: 'warehouseproconfig',
        component: () => import('@/views/WarehouseProConfig.vue'),
        // component: WarehouseProConfig,
      },
      {
        path: '/SalesProConfig',
        name: 'salesproconfig',
        component: () => import('@/views/SalesProConfig.vue'),
        // component: SalesProConfig,
      },
      {
        path: '/TransactionConfig',
        name: 'TransactionConfig',
        component: () => import('@/views/TransactionConfig.vue'),
        // component: TransactionConfig,
      },
      {
        path: '/TimeZoneConfig',
        name: 'TimeZoneConfig',
        component: () => import('@/views/TimeZoneConfig.vue'),
        // component: TimeZoneConfig,
      },
    ]
  },
  {
    path: '/ActionList',
    name: 'actionlist',
    component: () => import('@/views/ActionList.vue'),
    // component: ActionList,
    props: true,
    children: [
      {
        name:'actionlist',
        path: '',
        redirect: {
          name: 'dashboard'
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        // component: Dashboard,
        alias: '/'
      },
      {
        path: '/Esign/esigndashboard',
        name: 'esignDashboard',
        component: () => import('@/views/EsignDashboard.vue')
        // component: EsignDashboard,
      },
      {
        path: '/tickets/:id',
        name: 'tickets',
        component: () => import('@/views/Tickets.vue'),
        // component: Tickets,
        props: true,
      },
      {
        path: '/settlements/:id',
        name: 'settlements',
        component: () => import('@/views/Settlements.vue'),
        // component: Settlements,
      },
      {
        path: '/Esign/SendContract/:id?',
        name: 'Esign',
        component: () => import('@/views/Esign.vue'),
        // component: Esign,
      },
      {
        path: '/Configuration',
        name: 'configuration',
        component: () => import('@/views/Configuration.vue'),
        // component: Configuration,
      },
      {
        path: '/Warehouse/ScheduleOrders',
        name: 'scheduleOrders',
        component: () => import('@/views/WarehouseProStageOrders.vue'),
        // component: WarehouseProStageOrders,
        alias: '/'
      },
      {
        path: '/Warehouse/TwilioAlertsConfiguration',
        name: 'TwilioAlertsConfiguration',
        component: () => import('@/views/TwilioAlertsConfiguration.vue'),
        // component: TwilioAlertsConfiguration,
        alias: '/'
      },
      {
        path: '/Warehouse/PhysicalCount',
        name: 'PhysicalCount',
        component: () => import('@/views/PhysicalCount.vue'),
        // component: PhysicalCount,
        alias: '/'
      },
      {
        path: '/Warehouse/PhysicalCountGrid',
        name: 'PhysicalCountGrid',
        component: () => import('@/components/PhysicalCountGrid.component.vue'),
        alias: '/'
      },
      {
        path: '/Warehouse/GeneralConfigurations',
        name: 'GeneralConfigurations',
        component: () => import('@/views/GeneralConfigurations.vue'),
        // component: GeneralConfigurations,
        alias: '/'
      },

    ]
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to: any, from: any, next: any) => {
  const publicPages = ['/login', '/appSettings', '/AdminPanel', '/ErrorStatusConfig', '/WarehouseProConfig', '/SalesProConfig', '/TransactionConfig', '/TimeZoneConfig'];
  const authRequired = !publicPages.includes(to.path);
  let isAuthenticated = localStorage.getItem("userData");
  if (authRequired && !isAuthenticated) {
    return next('/login');
  } else
    return next();
});

trackRouter(router);

export default router
